import React, { useState } from "react";
import Image from "../../../components/elements/Image";
import Input from "../../../components/form/Input";
import Button from "../../../components/forms/Button";
import { classNames } from "../../../helpers/classNames";
import Logo from "../../../assets/images/logo-memory-doodle-stack.svg";
import GoogleLogo from "../../../assets/image/google.svg";
import FacebookLogo from "../../../assets/image/facebook.svg";
import { authSignup } from "../../../services/authService";

const SignUp = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const [showPasswordRules, setShowPasswordRules] = useState(false);
  const [passwordStrength, setPasswordStrength] = useState("weak");
  const [passwordValidations, setPasswordValidations] = useState({
    length: false,
    uppercase: false,
    lowercase: false,
    number: false,
    specialChar: false,
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    if (name === "password") {
      const validations = {
        length: value.length >= 8,
        uppercase: /[A-Z]/.test(value),
        lowercase: /[a-z]/.test(value),
        number: /[0-9]/.test(value),
        specialChar: /[^A-Za-z0-9]/.test(value),
      };
      setPasswordValidations(validations);

      const validCount = Object.values(validations).filter(Boolean).length;
      if (validCount === 5) setPasswordStrength("strong");
      else if (validCount >= 3) setPasswordStrength("medium");
      else setPasswordStrength("weak");
    }
  };

  const handleSubmit = async () => {
    const { firstName, lastName, email, password, confirmPassword } = formData;

    if (!firstName || !lastName || !email || !password || !confirmPassword) {
      setErrorMsg("Please fill all fields.");
      return;
    }

    if (password !== confirmPassword) {
      setErrorMsg("Passwords do not match.");
      return;
    }

    setLoading(true);
    setErrorMsg("");

    const res = await authSignup({ firstName, lastName, email, password });

    // console.log(res, "fvhb");
    if (res?.error) {
      setErrorMsg(res?.message || "Signup failed");
    } else {
      // Optional: redirect or show success
      window.location.href = "/signin"; // or use navigate("/home")
    }

    setLoading(false);
  };
  const socialData = [
    { _id: 1, name: "Facebook", logo: FacebookLogo },
    { _id: 2, name: "Google", logo: GoogleLogo },
  ];

  const isFormValid =
    formData.firstName &&
    formData.lastName &&
    formData.email &&
    formData.password &&
    formData.confirmPassword &&
    passwordStrength === "strong" &&
    formData.password === formData.confirmPassword;

  return (
    <>
      <section className="relative min-h-[calc(100vh-6rem)] py-10 flex items-center overflow-hidden bg-md-pink-light-2">
        <div className="relative w-full px-4 sm:px-0 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto">
          <div className="w-full max-w-lg mx-auto space-y-8">
            <div className="h-36">
              <Image
                src={Logo}
                alt={""}
                width={"100%"}
                height={"100%"}
                effect={"blur"}
                classes={"object-contain"}
              />
            </div>
            <div className="text-center">
              <h1 className="font-BubblegumSans text-4xl text-md-dark">
                Let's get started!
              </h1>
              <div className="text-xl tracking-tight text-neutral-600">
                You are one step closer to creating your magical coloring book.
              </div>
            </div>
            <div className="relative bg-white shadow-md shadow-md-pink/10 py-6 px-6 rounded-xl space-y-6">
              {errorMsg && (
                <div className="text-red-600 text-sm">{errorMsg}</div>
              )}
              <div className="space-y-4">
                <div className="relative">
                  {/* <Input
                    inputPlaceholder={"Enter your full name"}
                    inputClasses={""}
                    labelClasses={""}
                    label={"Full Name"}
                    inputType={"text"}
                    inputName="fullName"
                    value={formData.fullName}
                    onChange={handleChange}
                  /> */}
                  <Input
                    inputPlaceholder={"Enter your first name"}
                    inputClasses={""}
                    labelClasses={""}
                    label={"First Name"}
                    inputType={"text"}
                    inputName="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                  />
                </div>
                <div className="relative">
                  <Input
                    inputPlaceholder={"Enter your last name"}
                    inputClasses={""}
                    labelClasses={""}
                    label={"Last Name"}
                    inputType={"text"}
                    inputName="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                  />
                </div>
                <div className="relative">
                  <Input
                    inputPlaceholder={"Enter your email address"}
                    inputClasses={""}
                    labelClasses={""}
                    label={"Email Address"}
                    inputType={"email"}
                    inputName="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
                <div className="relative">
                  <Input
                    inputPlaceholder={"Create a secure password"}
                    inputClasses={""}
                    labelClasses={""}
                    label={"Create Password"}
                    inputType={"password"}
                    inputName="password"
                    value={formData.password}
                    onChange={handleChange}
                    onFocus={() => setShowPasswordRules(true)}
                    onBlur={() =>
                      setTimeout(() => setShowPasswordRules(false), 200)
                    }
                  />
                  {showPasswordRules && (
                    <div className="absolute z-10 mt-1 w-full bg-white border border-slate-200 shadow-md rounded-md p-3 text-sm text-left space-y-1">
                      <div
                        className={
                          passwordValidations.length
                            ? "text-green-600"
                            : "text-red-500"
                        }
                      >
                        • At least 8 characters
                      </div>
                      <div
                        className={
                          passwordValidations.uppercase
                            ? "text-green-600"
                            : "text-red-500"
                        }
                      >
                        • One uppercase letter
                      </div>
                      <div
                        className={
                          passwordValidations.lowercase
                            ? "text-green-600"
                            : "text-red-500"
                        }
                      >
                        • One lowercase letter
                      </div>
                      <div
                        className={
                          passwordValidations.number
                            ? "text-green-600"
                            : "text-red-500"
                        }
                      >
                        • One number
                      </div>
                      <div
                        className={
                          passwordValidations.specialChar
                            ? "text-green-600"
                            : "text-red-500"
                        }
                      >
                        • One special character
                      </div>
                    </div>
                  )}

                  <div className="mt-4 space-y-2">
                    <div className="relative overflow-hidden rounded-full h-2 bg-slate-100">
                      <div
                        className="absolute top-0 left-0 h-full rounded-full transition-all duration-300"
                        style={{
                          width:
                            passwordStrength === "strong"
                              ? "100%"
                              : passwordStrength === "medium"
                              ? "70%"
                              : "40%",
                          backgroundColor:
                            passwordStrength === "strong"
                              ? "#22c55e" // green-500
                              : passwordStrength === "medium"
                              ? "#facc15" // yellow-400
                              : "#f87171", // red-400
                        }}
                      ></div>
                    </div>
                    <div className="text-neutral-500 text-sm font-medium capitalize">
                      Password strength: {passwordStrength}
                    </div>
                  </div>
                </div>
                <div className="relative">
                  <Input
                    inputPlaceholder={"Confirm your password"}
                    inputClasses={""}
                    labelClasses={""}
                    label={"Confirm Password"}
                    inputType={"password"}
                    inputName="confirmPassword"
                    value={formData.confirmPassword}
                    onChange={handleChange}
                  />
                </div>
                <div className="relative !mt-8">
                  {/* {console.log(isFormValid)} */}
                  <Button
                    buttonLabel={loading ? "Creating..." : "Create Account"}
                    // buttonClasses={"!rounded-md !pb-1 w-full"}
                    buttonClasses={classNames(
                      "!rounded-md !pb-1 w-full",
                      isFormValid
                        ? "!bg-md-pink"
                        : "!bg-md-pink/50 cursor-not-allowed"
                    )}
                    buttonLabelClasses={"!text-xl font-medium"}
                    buttonFunction={handleSubmit}
                    disabled={!isFormValid || loading}
                  />
                </div>
              </div>
              <div className="overflow-hidden flex items-center justify-center relative">
                <span
                  className={classNames(
                    "relative inline-flex items-center justify-center bg-transparent text-slate-400 capitalize",
                    "before:content-[''] before:absolute before:top-1/2 before:left-[calc(100%+12px)] before:w-[400px] before:border-t before:border-slate-200 before:mt-px",
                    "after:content-[''] after:absolute after:top-1/2 after:right-[calc(100%+12px)] after:w-[400px] after:border-t after:border-slate-200 after:mt-px"
                  )}
                >
                  or
                </span>
              </div>
              {socialData?.length > 0 && (
                <div className="flex items-center justify-center gap-2">
                  {socialData.map((item, index) => (
                    <Button
                      key={item._id}
                      buttonClasses="!bg-transparent !rounded-md !p-2 !h-auto border border-slate-200 w-full hover:!bg-md-pink-light-2 hover:!border-md-pink-light-1"
                      buttonLabel={
                        <div className="flex items-center gap-1 md:gap-2">
                          <div className="w-8 aspect-square overflow-hidden">
                            <Image
                              src={item.logo}
                              alt={item.name}
                              effect={"blur"}
                              classes={"object-contain"}
                            />
                          </div>
                          <div className="text-md-dark text-base font-medium tracking-wide">
                            {item.name}
                          </div>
                        </div>
                      }
                    />
                  ))}
                </div>
              )}
              <div className="text-center flex items-center justify-center text-base text-slate-400">
                <span>Already have an account?</span>
                <Button
                  buttonLabel={"Sign In"}
                  buttonLabelClasses={"!font-semibold"}
                  buttonClasses={
                    "!h-6 !px-1 !bg-white !text-md-pink !rounded-none hover:underline"
                  }
                  buttonHasLink={true}
                  buttonLink={"/signin"}
                />
                <span>here</span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SignUp;
